import { graphql } from "gatsby";
import styles from "./ride-block.module.less";
import borderPatterns from "styles/theming/border-patterns.module.less";
import UtilityAreaRide from "components/block-elements/utility-area-ride/utility-area-ride";
import { extract } from "@parksandresorts/core";
import { useFetchQueueTime } from "components/hooks/queue-time-hooks";
import { useDisplayAttractionQueueTime } from "components/hooks/queue-time-hooks";
import RichTextRenderer from "components/block-elements/rich-text-renderer/rich-text-renderer";

const RideBlock = (props) => {
  const {
    title,
    borderPattern,
    componentTheme,
    rideId,
    minimumHeight,
    couponCount,
    couponText,
    ageRequirement,
    separateTickets,
    noHeightRequirement,
    richTextDescription,
  } = props;

  function doesQueueTimeObjectExistForRide(queueTime) {
    //The queueTime object can be either a single object or an array of objects
    //When its an array, it means we didn't find a queue time for the ride
    return queueTime && !Array.isArray(queueTime);
  }

  const preamble = extract(props, "preamble.preamble");
  const displayAttractionQueueTime = useDisplayAttractionQueueTime();
  const queueTime = useFetchQueueTime(rideId);
  const queueTimeObjectExistForRide = doesQueueTimeObjectExistForRide(queueTime);

  return (
    <section
      className={[
        `block block--with-utility`,
        componentTheme ? `component-theme-${componentTheme}` : "",
        styles.rideBlock,
        borderPatterns[borderPattern + "_top"],
      ].join(" ")}
      data-contentful-id={props.contentful_id}
    >
      <div className={["block--max-width", styles.outerWrapper].join(" ")}>
        <UtilityAreaRide
          extraClass={styles.utilityArea}
          buttonDisabled={true}
          visible={true}
          couponCount={couponCount}
          couponText={couponText}
          minimumHeight={minimumHeight}
          separateTickets={separateTickets}
          ageRequirement={ageRequirement}
          noHeightRequirement={noHeightRequirement}
          queueTime={displayAttractionQueueTime && queueTimeObjectExistForRide && queueTime}
        />
        <div className={["block--padded", styles.contentWrapper].join(" ")}>
          {title && <h1 className={[styles.title, "hero-heading"].join(" ")}>{title}</h1>}
          {preamble && <div className={[styles.preamble, "preamble"].join(" ")}>{preamble}</div>}
          {richTextDescription && (
            <div className={styles.richTextWrapper}>
              <RichTextRenderer richTextData={richTextDescription} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
export default RideBlock;

export const fragmentRideBlock = graphql`
  fragment RideBlock on ContentfulRideBlock {
    __typename
    contentful_id
    id
    sortIndex
    title
    rideId
    borderPattern
    componentTheme
    couponCount
    couponText
    minimumHeight
    minimumHeightInteger
    noHeightRequirement
    ageRequirement
    separateTickets
    preamble {
      preamble
    }
    richTextDescription {
      raw
    }
    shortDescriptionInList
    imageInList {
      description
      file {
        url
      }
    }
    label
    pageLink {
      slug
    }
    tags {
      title
    }
    mapLink {
      ...Link
    }
    queueDisplayCategory {
      title
    }
  }
`;
